var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.051.054a.5.5 0 0 0-.595.493v1.445a4 4 0 0 0-4.5 4.482H.509a.5.5 0 0 0-.5.593A6.04 6.04 0 1 0 7.051.054Zm-1.1 6.923a1 1 0 0 1-.868-.5H3.938a.5.5 0 0 1 0-1h1.147a1 1 0 0 1 .364-.363V3.463a.5035.5035 0 0 1 1.007 0v1.645a1 1 0 0 1-.5 1.869h-.005ZM4.931 0a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1ZM2.867.881a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1ZM1.309 2.38a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1ZM.504 4.471a.5.5 0 1 1 0 .9999.5.5 0 0 1 0-.9999Z",
    fill: "#357BFF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.ace1ddaeb89470f1af872957dce2c9ac.svg";
export { ForwardRef as ReactComponent };